import { motion } from "framer-motion";
import QuoteModal from "@/components/QuoteModal";
const aboutImg = "/images/site/ed-malaski-family-1-wood-floors-owners.webp";

const OurStoryTeaser = () => (
  <section className="bg-foreground py-20 md:py-28 lg:py-36 overflow-hidden">
    <div className="max-w-[1200px] mx-auto px-5 md:px-12 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
      {/* Text Column */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="order-2 md:order-1"
      >
        <p className="text-[11px] font-semibold tracking-[.14em] uppercase text-[hsl(var(--gold-400))] mb-2">
          Family Owned &amp; Locally Rooted
        </p>
        <h2 className="font-display text-[clamp(28px,4.5vw,52px)] font-semibold text-primary-foreground leading-[1.1] tracking-tight mb-5 md:mb-6">
          From Our Family<br className="hidden sm:block" /> to Your Home.
        </h2>
        <p className="text-[13px] md:text-[15px] font-light text-primary-foreground/50 leading-relaxed mb-4">
          Our heart is in Livonia. Our showroom and Michigan Plank Floor Covering, the hardwood manufacturer we own, are on Seven Mile Road West, near Laurel Park Place, and every crew starts its day here. We have been a licensed Michigan residential builder since 2017, fully insured, with Four NWFA Certifications and 30+ years in Michigan.
        </p>
        <p className="text-[13px] md:text-[15px] font-light text-primary-foreground/50 leading-relaxed mb-4">
          For our Northern Michigan clients, our family cottage in <a href="/hardwood-flooring/bellaire-mi" className="text-primary-foreground/80 underline-offset-4 hover:underline hover:text-primary-foreground transition-colors">Bellaire</a> serves as home base. This allows us to personally supervise projects from <a href="/hardwood-flooring/traverse-city-mi" className="text-primary-foreground/80 underline-offset-4 hover:underline hover:text-primary-foreground transition-colors">Traverse City</a> to <a href="/hardwood-flooring/bay-harbor-mi" className="text-primary-foreground/80 underline-offset-4 hover:underline hover:text-primary-foreground transition-colors">Bay Harbor</a>, wrapping up installations before the summer season begins.
        </p>
        <p className="text-[13px] md:text-[15px] font-light text-primary-foreground/50 leading-relaxed mb-8 md:mb-10">
          We raised our kids right here in this community. Our son is currently serving in the United States Navy. For us, this isn't just business. It's deeply personal. When you partner with 1 Wood Floors, you're not hiring a contractor. You're gaining a relationship with a local family.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <QuoteModal
            trigger={
              <button className="bg-primary text-primary-foreground px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-[hsl(var(--gold-400))] transition-colors text-center">
                Schedule a Showroom Consultation
              </button>
            }
          />
          <a
            href="tel:2483258853"
            className="border border-primary-foreground/15 text-primary-foreground/70 px-7 py-3.5 rounded-full text-sm font-medium hover:border-primary-foreground/30 hover:text-primary-foreground transition-all text-center"
          >
            📞 Call (248) 325-8853
          </a>
        </div>
      </motion.div>

      {/* Image Column */}
      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.15 }}
        className="order-1 md:order-2 relative"
      >
        <div className="relative rounded-[20px] overflow-hidden aspect-[4/5] max-h-[520px]">
          <img width={800} height={534} loading="lazy"
            src={aboutImg}
            alt="Ed Malaski and family, owners of 1 Wood Floors"
            className="w-full h-full object-cover grayscale-[20%] contrast-[1.1] hover:grayscale-0 hover:scale-[1.04] transition-all duration-700"
          />
          {/* Cinematic fade into dark background */}
          <div className="absolute inset-0 bg-gradient-to-t from-foreground via-foreground/20 to-transparent pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-foreground/30 pointer-events-none hidden md:block" />
        </div>
        <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8">
          <span className="font-display text-3xl md:text-4xl font-semibold text-primary-foreground leading-none block">Livonia, MI</span>
          <span className="text-[9px] md:text-[10px] font-semibold tracking-[.14em] uppercase text-primary-foreground/40 mt-1 block">Family Owned</span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default OurStoryTeaser;
